import * as req from 'api/actions';
import * as c from './constant';

export const getLandRecordofSupAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments`,
    payload,
    callback
  );

export const getSingleLandRecordofSupAssessment = (id, landRecordofSupAssessmentId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    callback
  );

export const createLandRecordofSupAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandRecordofSupAssessment = (id, landRecordofSupAssessmentId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandRecordofSupAssessment = (id, landRecordofSupAssessmentId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const findTdn = (payload, callback) =>
  req.create(
    c.FIND_TDN,
    '/api/v1/rpt/administrator/land/land_applications/search_tdn',
    payload,
    ({ res }) => {
      const data = res.res;
      if (callback) callback(data);
    }
  );

export const getTdn = (payload, callback) =>
  req.item(
    c.GET_TDN,
    `/api/v1/rpt/administrator/land/tdn`,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    },
    payload,
  );